/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonSerieUserRegistrationResponse,
    JsonSerieUserRegistrationResponseFromJSON,
    JsonSerieUserRegistrationResponseFromJSONTyped,
    JsonSerieUserRegistrationResponseToJSON,
} from './JsonSerieUserRegistrationResponse';

/**
 * 
 * @export
 * @interface ApiResultOfJsonSerieUserRegistrationResponse
 */
export interface ApiResultOfJsonSerieUserRegistrationResponse {
    /**
     * 
     * @type {JsonSerieUserRegistrationResponse}
     * @memberof ApiResultOfJsonSerieUserRegistrationResponse
     */
    data?: JsonSerieUserRegistrationResponse;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonSerieUserRegistrationResponse
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonSerieUserRegistrationResponse
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonSerieUserRegistrationResponse
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonSerieUserRegistrationResponse
     */
    result?: ApiResultOfJsonSerieUserRegistrationResponseResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonSerieUserRegistrationResponseResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonSerieUserRegistrationResponseFromJSON(json: any): ApiResultOfJsonSerieUserRegistrationResponse {
    return ApiResultOfJsonSerieUserRegistrationResponseFromJSONTyped(json, false);
}

export function ApiResultOfJsonSerieUserRegistrationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonSerieUserRegistrationResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonSerieUserRegistrationResponseFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonSerieUserRegistrationResponseToJSON(value?: ApiResultOfJsonSerieUserRegistrationResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonSerieUserRegistrationResponseToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

